import { createGenericDispatcher } from './action-dispatcher-factory';
import { industriesStateSelector } from '../reducers/industry-selectors';

import * as Api from '../api/api';

export const loadIndustries = () =>
  createGenericDispatcher({
    name: 'LOAD_INDUSTRIES',
    loadFunction: () => Api.get('/industries'),
    args: {},
    shouldExecuteSelector: (state: any) => industriesStateSelector(state),
  });
